/** Magico `configs` keys. Read values via `@utilities/magicoConfig` — "false" is truthy. */
export const MAGICO_CONFIG_KEYS = {
  HIDE_PLAYERS_COUNT: "hide_players_count",
} as const;

export const ROUTES = [
  {
    key: "levels",
    route: "Tiers",
  },
  {
    key: "promotions",
    route: "/Promotions",
  },
  { label: "privacyPolicy", route: "/PrivacyPolicy" },
  { label: "termsConditions", route: "/terms" },
  {
    label: "contactUs",
    route: "/ContactUs",
  },
  {
    label: "myAccount",
    route: "/AccountInfo",
  },
  { label: "logout", action: "logout" },
];
